// S25: Admin Overview API Types and Endpoints
import { apiClient } from './client';
import type { AuditLog } from './auditLogEndpoints';

export interface ProfitEntrySummary {
  id: string;
  gross_cents: number;
  net_cents: number;
  created_at: string;
}

export interface WeeklySettlementSummary {
  id: string;
  week_ending_at: string;
  status: 'pending' | 'completed' | 'failed';
  applied_at: string | null;
  profit_entry_id: string | null;
}

export interface AdminOverview {
  // Pool summary
  total_pool_cents: number;
  active_contributor_count: number;

  // Last profit entry
  last_profit_entry: ProfitEntrySummary | null;

  // Last weekly settlement
  last_weekly_settlement: WeeklySettlementSummary | null;

  // Open actions - withdrawals
  pending_withdrawals_count: number;
  pending_withdrawals_total_cents: number;
  approved_withdrawals_count: number;
  approved_withdrawals_total_cents: number;

  // Open actions - profit entries
  undistributed_profit_entries_count: number;

  // Recent audit events
  recent_audit_events: AuditLog[];
}

export const adminOverviewEndpoints = {
  getOverview: async (): Promise<AdminOverview> => {
    return await apiClient.get('/api/admin/overview');
  },
};
